import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.getToken()) {
      if (this.authService.isTokenExpired()) {
        this.authService.logout();
        this.router.navigate(['/mktmedilink']).then(r => console.log('A donde tan peinado master:', r));
        return false;
      }
      return true;
    }
    this.router.navigate(['/']).then(r => console.log('A donde tan peinado master:', r));
    return false;
  }
}
